import { render } from "./SituationStep.vue?vue&type=template&id=7b0244a3"
import script from "./SituationStep.vue?vue&type=script&lang=ts"
export * from "./SituationStep.vue?vue&type=script&lang=ts"
script.render = render

export default script